import moment from "moment-timezone";
export const getRole = (message) => {
  if (message.from) return message.from;
  return "customer";
};
export const getName = (data) => {
  const message = data.message || {};
  const role = getRole(message);
  let display = "";
  if (role == "flow") {
    display = "System";
  } else if (role == "agent") {
    display = data.agent && data.agent.name ? data.agent.name : "";
  } else if (role == "customer") {
    display =
      data.customer && data.customer.display ? data.customer.display : "";
  }
  return display || "UNKNOWN";
};

export const getNameCall = (data) => {
  const message = data || {};
  const role = getRole(message);
  let display = "";
  if (role == "flow") {
    display = "System";
  } else if (role == "customer") {
    display = 'Customer'
  } else if (role == "agent") {
    display = data.info && data.info.name ? data.info.name : ""
  }
  return display || "UNKNOWN";
};


export const getPlatform = (data) => {
  const message = data.message || {};
  const role = getRole(message);
  let platform = "";
  if (role == "flow") {
    platform = "NoImg";
  } else if (role == "agent") {
    platform = "NoImg";
  } else if (role == "customer") {
    platform = data.plateform ? data.plateform : "";
  }
  return platform || "UNKNOWN";
};

// export function convertTimeIntoHourMin(second) {
//   if (!second) {
//     return 0;
//   }

//   const timestamp = second;
//   const date = new Date(timestamp);
//   const hours = date.getUTCHours();
//   const minutes = date.getUTCMinutes();

//   const time = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
//     2,
//     "0"
//   )}`;

//   // let hours = Math.floor(second / 3600);
//   // let minutes = Math.floor((second - hours * 3600) / 60);
//   // let seconds = second - hours * 3600 - minutes * 60;

//   // if (hours < 10) {
//   //   hours = "0" + hours;
//   // }
//   // if (minutes < 10) {
//   //   minutes = "0" + minutes;
//   // }
//   // if (seconds < 10) {
//   //   seconds = "0" + seconds;
//   // }
//   // const convertedTime = moment(date).tz(getTimezone(localStorage.getItem(timezone.value)))
//   return time;
// }
export const getTimeZone = () => {
  const timezoneData = localStorage.getItem("timezone");
  if (timezoneData) {
    try {
      const parsedData = JSON.parse(timezoneData);
      return parsedData.value || "UTC"; // Return the timezone value or default to UTC
    } catch (error) {
      console.error("Error parsing timezone from localStorage:", error);
      return "UTC"; // Fallback if JSON parsing fails
    }
  }
  return "UTC"; // Default if localStorage is empty
};

export function convertTimeIntoHourMin(second) {
  if (!second) {
    return "00:00"; // Return a valid time format if input is falsy
  }

  const timestamp = second;
  const date = new Date(timestamp);

  console.log('date', date)

  const timezone = getTimeZone(); // Get timezone from localStorage2025-02-13T11:16:03.453Z
  console.log('timezone', timezone)
  const convertedTime = moment(date).tz(timezone).format("HH:mm"); // Format as HH:mm
  console.log('convertedTime', convertedTime)

  return convertedTime;
}


export const formatMessage = (message) => {
  return message
    .replace(/\n/g, '<br>') // Replace newlines with <br>
    .replace(/ {2}/g, ' &nbsp;'); // Replace multiple spaces with non-breaking spaces
};

export const formatMessageText = (message) => {
  console.log('messageType', message);
  if (typeof message !== 'string') {
    return '';
  }

  return message
    .replace(/<\/?div>/g, '') // Remove all <div> tags
    .replace(/\n+/g, ' ')  // Replace multiple newlines with a single space
    .replace(/<br\s*\/?>/g, ' ') // Remove <br> tags
    .replace(/\s+/g, ' ')  // Replace multiple spaces with a single space
    .trim(); // Trim spaces at the start and end
};




// WEBPACK FOOTER //
// src/modules/screens/chatscreen/components/utils/generic.js